import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdTipoMetrica } from "@/shared/actions";
import SaveTipoMetrica from "../../components/save-tipo-metrica/SaveTipoMetrica";

export default function UpdateTipoMetricaPage() {
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useFetchGetByIdTipoMetrica(id!);
  if (isLoading || isRefetching) return <LoaderComponent />;
  return <SaveTipoMetrica titulo="Actualizar tipo de métrica" data={data?.data} />;
}
